<script setup>
import SInfoMontant from '@/components/global/s-info-montant.vue'
import { computed } from 'vue'
import AjouterOperationAjustementForm from '@/components/fiche-aim/fiche-aim/ajustement/operation/ajouter-operation-ajustement-form.vue'
import LigneOperationAjustement from '@/components/fiche-aim/fiche-aim/ajustement/operation/ligne-operation-ajustement.vue'

const emits = defineEmits(['add', 'update', 'delete'])

const { loading, operations, postesDisponibles } = defineProps({
  loading: { type: Boolean, default: false },
  operations: { type: Array, required: true },
  postesDisponibles: { type: Array, required: true },
})

const postesNonDefinits = computed(() => postesDisponibles.filter((posteAIM) => !existeDansAjustement(posteAIM)))
const totalAjustement = computed(() => {
  let sum = 0
  for (let i = 0; i < operations.length; i++) {
    sum += operations[i].montant
  }
  return sum
})

function existeDansAjustement(posteAIM) {
  return operations.some((op) => op.posteAIM.posteAIMId === posteAIM.posteAIMId)
}
</script>

<template>
  <v-simple-table height="350px" class="table" fixed-header>
    <thead>
      <tr>
        <th>Poste</th>
        <th class="text-right">montant</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ajouter-operation-ajustement-form :postes-non-definits="postesNonDefinits" @add="(args) => emits('add', args)" />
      <template v-if="loading">
        <v-progress-circular indeterminate />
        <label>Chargement en cours</label>
      </template>
      <ligne-operation-ajustement
        v-else
        v-for="(op, i) in operations"
        :key="i"
        :operation="op"
        @update="(args) => emits('update', args)"
        @del="() => emits('delete', op.posteAIM.posteAIMId)"
      />
      <tr>
        <th class="text-right"></th>
        <th class="text-right">
          Total :
          <s-info-montant :montant="totalAjustement"></s-info-montant>
        </th>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<style>
textarea {
  height: 100px !important;
}
</style>
